import React, { useState } from 'react';
import HandleForm from './HandleForm';
import { TicketFormModel } from '../../models/ticket.model';
import { SubmitHandler } from 'react-hook-form';
import { createTicket, editTicket, editTicketAlarms } from '../../services/ticket.service';
import PrimaryMenuBar from '../TicketActions/TicketViewActions/PrimaryMenuBar';
import { Link, Typography } from '@mui/material';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import useUser from "../../hooks/useUser"
import { useNotification } from '../../context/NotificationContext';


interface TicketCreateFormProps {
  setBlockScreen: (p: boolean) => void
  action: string
  ticketForm: TicketFormModel
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleSelection?: (key: string, value: string) => void
  handleCheck?: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleCustomFieldChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TicketCreateForm: React.FC<TicketCreateFormProps> = ({ setBlockScreen, action, ticketForm, 
  handleChange, handleSelection, handleCheck, handleCustomFieldChange }) => {

  const navigate = useNavigate()
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [currentAction, setCurrentAction] = useState<string>(action)
  const { userAdmin } = useUser()

  const onSubmit: SubmitHandler<TicketFormModel> = () => {
    setBlockScreen(true);
    let apiCall;
    switch (currentAction) {
      case 'create':
        apiCall = createTicket(selectedProject, ticketForm);
        break;
      case 'edit':
        apiCall = editTicket(selectedProject, ticketForm.number, ticketForm);
        break;
      case 'edit_alarms':
        apiCall = editTicketAlarms(selectedProject, ticketForm.number, ticketForm);
        break;
    }
    if (!apiCall) navigate("/tickets/listing");

    Promise.all([apiCall]).then(function (results) {
      showNotification(
        <Typography component='span'>
          <i>Ver Incidencia </i>
          <Link
            sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
            underline='hover'
            href={`/${selectedProject}/ticket/view/${results[0]['ticket_number']}/0`}
          >
            {results[0]['ticket_number']}
          </Link>
        </Typography>);
      setBlockScreen(false);
      navigate("/tickets/listing")
    }).catch((error) => {
      showNotification(error.response?.data, 'error')
      setBlockScreen(false)
    });
  };

  return (
    <React.Fragment>
      {(action !== 'create') &&

        (<div className='indicators-actions-section'>

          <div className='inidicators-section'>
            <IndicatorChip
              label={`Abierto por ${ticketForm.created_by.label}`}
              iconDecoration={<PersonOutlineOutlinedIcon />}
            />
            <IndicatorChip
              label={`Apertura ${ticketForm.created_date}`}
              iconDecoration={<EventAvailableOutlinedIcon />}
            />
          </div>
          <div>
            <PrimaryMenuBar
              ticket_number={ticketForm.number}
              ticket_status_n={ticketForm.status_n}
              action={currentAction}
              setCurrentAction={setCurrentAction}
              canEdit={userAdmin}
            />
          </div>

        </div>
        )}

      <HandleForm
        action={currentAction}
        ticketForm={ticketForm}
        onSubmit={onSubmit}
        handleChange={handleChange}
        handleSelection={handleSelection}
        handleCheck={handleCheck}
        setBlockScreen={setBlockScreen}
        handleCustomFieldChange={handleCustomFieldChange}
        selectedProject={selectedProject ? selectedProject : ticketForm.number.substring(0, 2)}
      />

    </React.Fragment>
  );
}

export default TicketCreateForm;